"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBlurAll = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _cell = require("@react-page/core/lib/actions/cell");

var _reduxConnect = require("@react-page/core/lib/reduxConnect");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var MAX_LEVEL = 10; // this might break in future, but its better than nothing
// tslint:disable-next-line:no-any

function findReactElement(node) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (level >= MAX_LEVEL) {
    return null;
  }

  for (var key in node) {
    if (key.startsWith('__reactInternalInstance$')) {
      return node[key];
    }
  }

  if (node.parentElement) {
    return findReactElement(node.parentElement, level++);
  }

  return null;
}

function isCKEditorToolbar(node) {
  if (!(node instanceof HTMLElement)) {
    return isCKEditorToolbar(node.parentElement);
  }

  return !!node.className.split(' ').find(function (item) {
    return item === 'ck';
  });
}

var isInSameTree = function isInSameTree(parent, child) {
  if (!parent) {
    return false;
  }

  if (isCKEditorToolbar(child)) {
    return true;
  }

  var element = findReactElement(child);

  while (element) {
    if (element.stateNode === parent) {
      return true;
    }

    element = element["return"];
  }

  return false;
};

var useBlurAll = function useBlurAll(blurAllCellsDispatch) {
  var ref = _react["default"].useRef();

  (0, _react.useEffect)(function () {
    if (!ref.current) {
      return null;
    }

    if (!document && !document.body) {
      return null;
    }

    var onMouseDown = function onMouseDown(e) {
      if (!isInSameTree(ref.current, e.target)) {
        blurAllCellsDispatch();
      }
    };

    document.body.addEventListener('mousedown', onMouseDown);
    return function () {
      document.body.removeEventListener('mousedown', onMouseDown);
    };
  }, [ref.current]);
  return ref;
};

exports.useBlurAll = useBlurAll;
var mapDispatchToProps = {
  blurAllCells: _cell.blurAllCells
};

var BlurGate = function BlurGate(props) {
  var ref = useBlurAll(props.blurAllCells);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref
  }, props.children);
};

var _default = (0, _reduxConnect.connect)(null, mapDispatchToProps)(BlurGate);

exports["default"] = _default;